/* global ReactSpringserveComponent */

angular.module('vastdesk').component('magniteAgentDrawer', {
  template: require('../templates/magniteAgentDrawer.html'),
  bindings: {
    linkId: '@',
    title: '@',
    agentId: '@',
    magniteAiRoot: '@',
    authToken: '@',
  },
  controllerAs: '$magniteAgentDrawerCtrl',
  controller: [
    '$scope',
    function ($scope) {
      const self = this;

      this.rootId = `component-root-angular-MagniteAgentDrawer-${crypto.randomUUID()}`;

      this.open = false;
      this.unregisterWatcher = null;

      this.handleClose = () => {
        self.open = false;
        $scope.$apply();
      };

      this.openDrawer = () => {
        self.open = true;
        $scope.$apply();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: 'MagniteAgentDrawer',
            rootId: self.rootId,
            componentProps: {
              title: self.title,
              open: self.open,
              onClose: self.handleClose,
              agentId: self.agentId,
              magniteAiRoot: self.magniteAiRoot || '',
              authToken: self.authToken || '',
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watch(
            '$magniteAgentDrawerCtrl.open',
            (open) => {
              $('header').toggleClass('drawer-open', open);
              self.renderReactComponent();
            }
          );
        });

        $(document).on('click', self.linkId, function (e) {
          e.preventDefault();
          self.openDrawer();
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
        $(document).off('click', self.linkId);
      };
    },
  ],
});
